import React, { useEffect, useState } from "react";
import { Outlet, useLocation, NavLink } from "react-router-dom";
import "./MobileLayout.css";

// ✅ Icons import
import { RxDashboard } from "react-icons/rx";
import { FiUser } from "react-icons/fi";
import { MdOutlineCategory, MdProductionQuantityLimits } from "react-icons/md";
import { BiCoinStack } from "react-icons/bi";
import MobileHeader from "../MobileHeader/MobileHeader";

const MobileLayout = () => {
    const location = useLocation();
    const [pageTitle, setPageTitle] = useState("Dashboard");

    useEffect(() => {
        const pathToTitle = {
            "/adminm/dashboard": "Dashboard",
            "/adminm/customers-list": "Customer List",
            "/adminm/category-list": "Category List",
            "/adminm/product-list": "Product List",
            "/adminm/coin-allot": "Coin Allot",
        };

        if (pathToTitle[location.pathname]) {
            setPageTitle(pathToTitle[location.pathname]);
        }
    }, [location]);

    return (
        <div className="mobile-layout">
            <div className="mobile-header">
                <MobileHeader title={pageTitle} />
            </div>

            <main className="mobile-main">
                <Outlet />
            </main>
            <nav className="mobile-bottom-nav">
                <ul>
                    <li>
                        <NavLink
                            to="/adminm/dashboard"
                            className={({ isActive }) => (isActive ? "active" : "")}
                        >
                            <RxDashboard />
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to="/adminm/customers-list"
                            className={({ isActive }) => (isActive ? "active" : "")}
                        >
                            <FiUser />
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to="/adminm/category-list"
                            className={({ isActive }) => (isActive ? "active" : "")}
                        >
                            <MdOutlineCategory />
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to="/adminm/product-list"
                            className={({ isActive }) => (isActive ? "active" : "")}
                        >
                            <MdProductionQuantityLimits />
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to="/adminm/coin-allot"
                            className={({ isActive }) => (isActive ? "active" : "")}
                        >
                            <BiCoinStack />
                        </NavLink>
                    </li>
                </ul>
            </nav>

        </div>
    );
};

export default MobileLayout;